import { useEffect, useMemo } from "react";
import { Coins } from "lucide-react";

// Full-screen coin-burst celebration. Renders nothing when amount is null.
export const CoinBurst = ({ amount, onDone }) => {
  const particles = useMemo(
    () =>
      Array.from({ length: 18 }, (_, i) => ({
        id: i,
        tx: (Math.random() - 0.5) * 320,
        ty: -120 - Math.random() * 260,
        delay: Math.random() * 0.25,
        scale: 0.6 + Math.random() * 0.9,
      })),
    // regenerate per celebration
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [amount]
  );

  useEffect(() => {
    if (amount == null) return;
    const t = setTimeout(() => onDone?.(), 2400);
    return () => clearTimeout(t);
  }, [amount, onDone]);

  if (amount == null) return null;
  return (
    <div data-testid="coin-burst-overlay" className="fixed inset-0 z-[100] pointer-events-none flex items-center justify-center">
      <style>{`
        @keyframes coinburst-fly {
          0% { transform: translate(0,0) scale(0.3) rotate(0deg); opacity: 0; }
          15% { opacity: 1; }
          100% { transform: translate(var(--tx), var(--ty)) scale(var(--s)) rotate(540deg); opacity: 0; }
        }
        @keyframes coinburst-pop {
          0% { transform: scale(0.4); opacity: 0; }
          40% { transform: scale(1.15); opacity: 1; }
          70% { transform: scale(1); }
          100% { transform: scale(1); opacity: 0; }
        }
      `}</style>
      {particles.map((p) => (
        <span
          key={p.id}
          className="absolute text-amber-400"
          style={{
            "--tx": `${p.tx}px`,
            "--ty": `${p.ty}px`,
            "--s": p.scale,
            animation: `coinburst-fly 1.8s cubic-bezier(0.2,0.7,0.4,1) ${p.delay}s forwards`,
          }}
        >
          <Coins size={22} fill="currentColor" />
        </span>
      ))}
      <div
        data-testid="coin-burst-amount"
        className="relative px-6 py-4 text-center"
        style={{ animation: "coinburst-pop 2.2s ease-out forwards" }}
      >
        <div className="font-display text-5xl text-amber-400 drop-shadow-[0_0_18px_rgba(251,191,36,0.6)]">
          +{Number(amount).toLocaleString()}
        </div>
        <div className="text-xs uppercase tracking-widest text-amber-200 mt-1">Panda Coins added</div>
      </div>
    </div>
  );
};
